import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1300px;
  display: flex;
  flex-direction: column;
  padding: 20px;

  @media (max-width: 750px) {
    padding: 10px 20px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 15px;

  h1 {
    margin: 0;
    text-align: left;
    color: #000;
    font-size: 28px;
  }

  .actions-container {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: wrap;
  }

  @media (max-width: 750px) {
    flex-direction: column;
    align-items: flex-start;
    
    h1 {
        font-size: 24px;
    }

    .actions-container {
        width: 100%;
        justify-content: space-between;
    }
  }
`;